// Afdrukken bij een asielverblijf. Een PDF is een geauthenticeerde binaire read en het token staat
// alleen in het geheugen (geen cookie), dus een gewone <a href> krijgt hem niet mee — net als bij de
// factuurexport halen we de blob op met het bearer-token erbij en openen die in een nieuw tabblad.
import { getAccessToken } from "../auth";

const API_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? "/api";

/** Een document dat bij dit verblijf afgedrukt kan worden. */
export interface AfdrukKeuze {
  sleutel: string;
  naam: string;
  categorie: string | null;
}

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

/** De documenten die het pension heeft klaarstaan. */
export async function haalAfdrukKeuzes(verblijfId: string): Promise<AfdrukKeuze[]> {
  const res = await fetch(`${API_URL}/asielverblijven/${verblijfId}/afdrukken`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data: unknown = await res.json();
  return Array.isArray(data) ? (data as AfdrukKeuze[]) : [];
}

/**
 * Het gekozen document openen. Een nieuw tabblad in plaats van een download: je wilt een afdruk
 * meestal zien en dan op printen drukken, niet eerst een bestand terugzoeken. Het object-URL blijft
 * even staan omdat het tabblad hem nog nodig heeft.
 */
export async function openAfdruk(verblijfId: string, sleutel: string): Promise<void> {
  const res = await fetch(`${API_URL}/asielverblijven/${verblijfId}/afdrukken/${encodeURIComponent(sleutel)}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const url = URL.createObjectURL(await res.blob());
  const venster = window.open(url, "_blank", "noopener");
  if (!venster) {
    // Pop-upblokkering: dan maar als download, zodat de klik niet in het niets valt.
    const a = document.createElement("a");
    a.href = url;
    a.download = `${sleutel.toLowerCase()}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
